import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessLoanComponent } from './business-loan/business-loan.component';
import { BusinessLoanRoutingModule } from './business-loan.routing';
import { PipesModule } from '../../../shared/pipes/pipes.module';
import { LoanHeaderComponent } from './loan-header/loan-header.component';
import { LoanInputComponent } from './loan-input/loan-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoanSelectComponent } from './loan-select/loan-select.component';
import { DividerComponent } from './divider/divider.component';
import { ButtonComponent } from './button/button.component';
import { SubHeaderComponent } from './sub-header/sub-header.component';
import { LoanTextareaComponent } from './loan-textarea/loan-textarea.component';
import { LoanDropdownComponent } from './loan-dropdown/loan-dropdown.component';
import { LoanRadioComponent } from './loan-radio/loan-radio.component';
import { LoanDatepickerComponent } from './loan-datepicker/loan-datepicker.component';
import { MatRadioButton, MatRadioGroup, MatRadioModule } from '@angular/material/radio';
import { LoanBtmButtonsComponent } from './loan-btm-buttons/loan-btm-buttons.component';
import { ApplicantFormComponent } from './applicant-form/applicant-form.component';
import { GuarantorFormComponent } from './guarantor-form/guarantor-form.component';
import { PrevNextComponent } from './prev-next/prev-next.component';
import { LoanCheckboxComponent } from './loan-checkbox/loan-checkbox.component';
import { TooltipModule } from '../tooltip/tooltip.module';
import { OpenApplicationComponent } from './open-application/open-application.component';

@NgModule({
    declarations: [
        BusinessLoanComponent,
        LoanHeaderComponent,
        LoanInputComponent,
        LoanSelectComponent,
        SubHeaderComponent,
        LoanTextareaComponent,
        LoanDropdownComponent,
        LoanRadioComponent,
        LoanDatepickerComponent,
        LoanBtmButtonsComponent,
        ApplicantFormComponent,
        GuarantorFormComponent,
        PrevNextComponent,
        LoanCheckboxComponent,
        OpenApplicationComponent,
    ],
    exports: [
        BusinessLoanComponent,
        LoanHeaderComponent,
        LoanInputComponent,
        LoanSelectComponent,
        SubHeaderComponent,
        LoanTextareaComponent,
        LoanDropdownComponent,
        LoanRadioComponent,
        LoanDatepickerComponent,
        LoanBtmButtonsComponent,
        ApplicantFormComponent,
        GuarantorFormComponent,
        PrevNextComponent,
        LoanCheckboxComponent,
    ],
    imports: [
        CommonModule,
        BusinessLoanRoutingModule,
        PipesModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DividerComponent,
        MatRadioModule,
        MatRadioButton,
        MatRadioGroup,
        TooltipModule,
        ButtonComponent
    ],
})
export class BusinessLoanModule { }
